import { useCallback, useMemo } from 'react';
import { createEnumDelimitedArrayParam, useQueryParams } from 'use-query-params';

export type SpaceTreeTag = 'HighlightRentables';
export type SpaceTreeTagColor = 'teal';

const TAG_OPTIONS: { value: NonNullable<SpaceTreeTag>, color: SpaceTreeTagColor }[] = [
  { value: 'HighlightRentables', color: 'teal' }
]

export const useSpaceTreeTags = () => {
  const [query, setQuery] = useQueryParams({
    spaceTreeTags: createEnumDelimitedArrayParam<SpaceTreeTag>(['HighlightRentables']),
  });

  const tags = query.spaceTreeTags;

  const hasTags = useMemo(() => Array.isArray(tags) && tags.length > 0, [tags]);

  const tagCount = useMemo(() => Array.isArray(tags) ? tags.length : 0, [tags]);

  const toggleTag = useCallback((tag: SpaceTreeTag) => {
    const updatedTags = Array.isArray(tags) && tags.length > 0 ? [...tags] : [];

    const index = updatedTags.findIndex((x) => x === tag);
    if (index >= 0) {
      updatedTags.splice(index, 1);
    } else {
      updatedTags.push(tag);
    }

    setQuery({ spaceTreeTags: updatedTags?.length > 0 ? updatedTags : undefined });
  }, [setQuery, tags]);

  const isTagActive = useCallback((tag: SpaceTreeTag) => !!tags?.includes(tag), [tags]);

  return { tags, hasTags, tagCount, toggleTag, isTagActive, TagOptions: [...TAG_OPTIONS] };
};
